/**
 * The tint behind a member's avatar is an HSL hue (§14.86). Members pick one from `AVATAR_HUES`;
 * until they do, it is the hash of their id that the builder and launcher always used, so nobody's
 * color changes on its own. Pure data, so the web app imports it through `@circles/convex`.
 */
export const AVATAR_HUES = [
  { hue: 0, label: 'Red' },
  { hue: 26, label: 'Orange' },
  { hue: 46, label: 'Yellow' },
  { hue: 100, label: 'Green' },
  { hue: 160, label: 'Mint' },
  { hue: 190, label: 'Teal' },
  { hue: 210, label: 'Blue' },
  { hue: 245, label: 'Indigo' },
  { hue: 285, label: 'Purple' },
  { hue: 325, label: 'Pink' },
] as const;

export function isAvatarHue(hue: number): boolean {
  return Number.isInteger(hue) && hue >= 0 && hue < 360;
}

/** The hue a member shows until they pick: the same hash as the web's `tint(memberId)`. */
export function autoAvatarHue(memberId: string): number {
  let h = 0;
  for (const ch of memberId) h = (h * 31 + ch.charCodeAt(0)) % 360;
  return h;
}
